import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import {
  isRequired,
  validateEndDate,
  validateNumber,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import DatePicker from '../../../common/forms/input/DatePicker';

const validateMyEndDate = (value, allValues) =>
  validateEndDate(value, allValues.startDate);

export const EditPricingProfileDateRangeForm = ({ handleSubmit, loading }) => {
  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup row>
          <FormItem label="Año">
            <Field
              name="year"
              component={TextInput}
              validate={[isRequired, validateNumber]}
            />
          </FormItem>
        </FormGroup>

        <FormGroup row>
          <FormItem label="Desde">
            <Field
              name="startDate"
              component={DatePicker}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Hasta">
            <Field
              name="endDate"
              component={DatePicker}
              validate={[isRequired, validateMyEndDate]}
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Motivo">
            <Field
              name="reason"
              component={TextInput}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        <FormFooter />
      </Form>
    </>
  );
};

EditPricingProfileDateRangeForm.propTypes = {
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
};

EditPricingProfileDateRangeForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.PricingProfileDateRange.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'EditPricingProfileDateRangeForm',
})(EditPricingProfileDateRangeForm);

export default connect(mapStateToProps, null)(formComponent);
